import React from 'react';
import LocalizedStatic, { getLoadables } from './static-utils';

const loadables = getLoadables('rss-feed');
export default () => <LocalizedStatic loadables={loadables}/>;



// WEBPACK FOOTER //
// ./src/views/static/rss-feed.js